var Handlebars = require('/var/www/html/node_modules/handlebars/runtime.js');
module.exports = (Handlebars['default'] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression;

  return "<span>"
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.client : depth0)) != null ? stack1.first_name : stack1), depth0))
    + " "
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.client : depth0)) != null ? stack1.last_name : stack1), depth0))
    + "</span>\n<span>"
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.client : depth0)) != null ? stack1.email : stack1), depth0))
    + "</span>\n<span class=\"attendee-actions\">\n  <a class=\"edit\"><i class=\"fa fa-edit\"><span class=\"visually-hidden\">Close</span></i></a>\n  <a class=\"delete\"><i class=\"fa fa-close\"><span class=\"visually-hidden\">Close</span></i></a>\n</span>";
},"useData":true});